<template>
  <div>
    <div class="tabbable tabbable-custom" :class="headerClass">
      <div :class="containerClass">
        <ul
          class="nav nav-tabs tw-border-b-1 tw-border-grey tw-border-solid"
          :class="{'nav-justified': justified}"
        >
          <li
            v-for="(item, index) in tabs"
            :key="$t('wi.'+item.label)"
            :class="{'active': index === 0}"
            @click="changeActiveTab(index)"
          >
            <a
              v-text="item.label"
              :href="`#${item.id}`"
              :class="item.classes"
              class="uppercase"
              data-toggle="tab"
            ></a>
          </li>
        </ul>
      </div>
    </div>
    <div :class="bodyClass">
      <div class="tab-content clearfix">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BlastTabs',

    props: {
      justified: {
        type: Boolean,
        default: true,
      },
      headerClass: {
        type: String,
        default: '',
      },
      bodyClass: {
        type: String,
        default: '',
      },
      containerClass: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        tabs: [],
      };
    },

    methods: {
      changeActiveTab(tabIndex) {
        this.tabs.forEach((tab, index) => {
          tab.isActiveData = index === tabIndex;
        });
      },
    },

    mounted() {
      this.$nextTick(() => this.tabs = this.$children);
    },
  };
</script>
